import appConfig from '~/config/app'

export function getFileUrl(key: string): string {
  return `${appConfig.assetsCdnUrl}/${encodeURIComponent(key)}`
}

export function getFileUrlWithoutEncoding(key: string): string {
  return `${appConfig.assetsCdnUrl}/${key}`
}
export function getImageUrlWithoutEncoding(key: string): string {
  return `${appConfig.imagesCdnUrl}/${key}`
}
